module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "title": "Epigraph"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("“What has been overlooked is the irrational, the inconsistent, the droll, even the insane, which nature, inexhaustibly operative, implants in an individual, seemingly for her own amusement.”")]), _vm._v(" "), _c('p', {
    staticClass: "att"
  }, [_vm._v("Albert Einstein")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d223714","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/02_Fm02.vue
// module id = 72
// module chunks = 0